// extracted by mini-css-extract-plugin
module.exports = {"toggler":"Toggler_toggler__JYFrA","justify-end":"Toggler_justify-end__3OQLH","checkbox":"Toggler_checkbox__IOSSd","slider":"Toggler_slider__2PXAf"};